import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

import {
  COMMUNITY_CATALOG_PARAM,
  CommunityCatalogParams,
  SOURCE_FILTER_ALL,
  SOURCE_FILTER_VALUES,
  SourceFilterValue,
} from '../config';

const parseSource = (raw: string | null): SourceFilterValue =>
  SOURCE_FILTER_VALUES.find((value) => value === raw) ?? SOURCE_FILTER_ALL;

export const useCommunityCatalogParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const params: CommunityCatalogParams = {
    query: searchParams.get(COMMUNITY_CATALOG_PARAM.q) ?? '',
    source: parseSource(searchParams.get(COMMUNITY_CATALOG_PARAM.source)),
    language:
      searchParams
        .get(COMMUNITY_CATALOG_PARAM.language)
        ?.trim()
        .toLowerCase() || null,
  };

  const updateParam = useCallback(
    (key: string, value: string | null) => {
      setSearchParams(
        (previous) => {
          const next = new URLSearchParams(previous);
          if (value === null || value === '') {
            next.delete(key);
          } else {
            next.set(key, value);
          }
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  const setQuery = useCallback(
    (value: string) => updateParam(COMMUNITY_CATALOG_PARAM.q, value),
    [updateParam],
  );

  const setLanguage = useCallback(
    (value: string) => updateParam(COMMUNITY_CATALOG_PARAM.language, value),
    [updateParam],
  );

  return { params, setQuery, setLanguage };
};
